import { Loader } from '@ui/components/Loader';

import styles from './LoginByTokenPage.module.css';

type Props = {
  status: 'loading' | 'error';
};

export function LoginByTokenPage({ status }: Props) {
  if (status === 'loading') {
    return (
      <div className={styles.loaderContent}>
        <Loader className={styles.loader} ignoreClubColors />
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <div className={styles.header}>Ошибка</div>
      <div className={styles.subTitle}>Не удалось авторизоваться</div>
    </div>
  );
}
